import React from 'react';
import {populate} from "../utils/populate";

class NewsFilter extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      baseQuery: "/rest/terms?_format=json",
      tags: [],
      committees: [],
      documents: [],
      papers: [],
      services: [],
      typed: '',
      selectTag: '',
      selectDate: ''
    };

    this.textInput = React.createRef();

    this.populateTags = this.populateTags.bind(this);
    this.populateCommittees = this.populateCommittees.bind(this);
    this.populateDocuments = this.populateDocuments.bind(this);
    this.populatePapers = this.populatePapers.bind(this);
    this.populateServices = this.populateServices.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onTagChange = this.onTagChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
  }

  componentDidMount() {
    this.populateTags();
  }

  populateTags() {
    const { baseQuery } = this.state;
    var that = this;
    populate(`${baseQuery}&taxonomy=tags`).then(function( response ){
      that.setState({
        tags: response
      })
    });
  }

  handleChange() {
    const { typed, selectTag, selectDate } = this.state;
    this.props.onUserInput(typed, selectTag, selectDate)
  }

  onTagChange(e) {
    this.setState({selectTag: e.target.value});
  }

  onDateChange(e) {
    this.setState({selectDate: e.target.value});
  }

  onInputChange(event) {
    this.setState({
      typed: event.target.value
    }, () => this.props.onInputChange(this.state.typed))
  }

  handleKeyPress(e) {
    const { typed } = this.state;
    "Enter" === e.key && this.props.onUserInput(typed)
  }

  populateCommittees() {}

  populateDocuments() {}

  populatePapers() {}

  populateServices() {}

  render() {
    const { title } = this.props;
    const { tags } = this.state;
      return(
        <div className="page--block background__mist"><h2 className="heading">{title}</h2>
          <div className="grid">
            <div className="col-12 margin__bottom">
              <label>Keywords</label>
              <input
                type="text"
                placeholder="Enter your keyword"
                value={this.state.typed}
                onChange={this.onInputChange}
                onKeyPress={this.handleKeyPress}
              />
            </div>
            <div className="col-6 margin__bottom">
              <label>Topic</label>
              <select onChange={this.onTagChange}>
                <option key="all" value='All'>All</option>
                {
                  tags.map(tag => {
                    return(
                      <option key={tag.tid} value={tag.tid}>{tag.name}</option>
                    )
                  })
                }
              </select>
            </div>
            <div className="col-6 margin__bottom">
              <label>Published within</label>
              <select onChange={this.onDateChange}>
                <option key="all" value="">All</option>
                <option key="2019" value="2019">2019</option>
                <option key="2018" value="2018">2018</option>
                <option key="2017" value="2017">2017</option>
                <option key="2016" value="2016">2016</option>
                <option key="2015" value="2015">2015</option>
              </select>
            </div>
            <div className="col-12 align__right">
              <button onClick={this.handleChange}>Search</button>
            </div>
          </div>
        </div>
      )
    }
}

export default NewsFilter;









